(function sortable() {

    $('.sortable').each(function(key, target) {
        $(target).sortable({
            start: function (event, ui) {
                $(ui.item).data('startindex', ui.item.index());
            },
            stop: function (event, ui) {
                sendUpdatedIndex(target);
                updateNames(target);
            }
        });
    });

    function updateNames(target)
    {
        if($(target).attr('data-sortable-type') === 'lesson_sheet') {
            $(target).children().map(function (key, item) {
                var name = $(item).attr('data-sortable-name');
                if ($(item).attr('data-sortable-id') !== undefined) {
                    $(item).html(name + ' ' + ($(item).index() + 1));
                }
            });
        }
    }


    function sendUpdatedIndex(target) {
        var data = {
            _token: $(target).attr('data-sortable-token'),
            data: []
        };

        $(target).children().map(function (key, item) {
            data.data.push({
                id: $(item).attr('data-sortable-id'),
                rank: $(item).index() + 1,
                type: $(target).attr('data-sortable-type')
            });
        });

        $.ajax({
            url: $(target).attr('data-sortable-url'),
            method: 'POST',
            data: JSON.stringify(data),
            statusCode: 200,
            dataType: 'json',
            contentType: 'application/json; charset=utf-8'
        });
    }
})();